import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Typography } from '@mui/material';
import { CommonTexts } from 'locale/es';
import { useNavigate } from 'react-router-dom';
import { AppColors } from 'resources/AppColors';

function EditMenuOption({ entity, showText, customURL, isParticipantContent, isDashboardView, textLink }) {
  const navigate = useNavigate()

  function handleEditForm() {
    navigate(
      !customURL
        ? `${entity.id}/edit`
        : `${customURL}`,
      { state: { entity: entity } }
    )
  }

  function handleInfoForm() {
    const basePath = isDashboardView
      ? "/dades-del-participant/contingut/patients"
      : "/contingut/patients";
    const path = `${basePath}/${entity.id}/info`;

    navigate(path, {
      state: { entity: entity },
    });
  }


  return (
    <Box onClick={isParticipantContent ? handleInfoForm : handleEditForm} p={"6px"} sx={{ width: "100%" }} >
       {isParticipantContent ? (
        <>
          <Typography
            variant='body'
            noWrap
            sx={{
              cursor: "pointer",
              "&:hover": {
                color: AppColors.PRIMARY,
              },
            }}
          >
            {textLink}
          </Typography>
        </>
      ) : (
        <>
          <IconButton data-cy='table-edit-button'>
            <EditIcon sx={{ fill: AppColors.PRIMARY }} />
            {showText && (
              <Typography variant='menu_list_text'>
                {CommonTexts.EDIT}
              </Typography>
            )}
          </IconButton>
        </>
      )}

    </Box>
  )
}

export default EditMenuOption